module.exports = __webpack_public_path__ + "img/deco-18.5df3bed7.png";